import React from 'react'

import WidgetAjax from "../../widget/WidgetAjax"
import Config from '../../config/Config'
import Cache from "../../frame/Cache";
import "../../css/HomePage.css"

class AllRankingWidget extends React.Component 
{
    constructor(props)
    {
        super(props);

        this.state = {
            BasePath:Config.getBasePath(),
            rankingTabNum:1,
            RankData:[],
            loading:true
        };

        this.loadJobRank = this.loadJobRank.bind(this);
        this.onloadJobRank = this.onloadJobRank.bind(this);

    }

    componentDidMount()
    {
        this.loadJobRank();
    }
    
    /**
     * 请求商机工作排名数据
     * @type {*} type (1-浏览量排名、2-下载量排名、3-外呼量排名)
     */
    loadJobRank(type = 1)
    {
        let { BasePath } = this.state;

        this.setState({rankingTabNum:type});

        WidgetAjax.ajax({url: BasePath + "/business/usage_rank", params: { "TYPE": type} , callback: this.onloadJobRank});
        this.setState({
            loading:true
        })
    }
 
     onloadJobRank( result )
     {
         if( result.status===0 )
         {
            this.setState({
                 RankData:result.results,
                 loading:false
             })
         }
         else if( result.status===10 ) 
         {
             Cache.logout(this.props);
         }
     }

    render() 
    {

        let { rankingTabNum, RankData,loading } = this.state

        return (
            <div className="rankingContent background-fff border-1 radius-5 box-shadow">
                <div className="WarningTitle lineheight-50 display-flex flex-row cursor-pointer ">
                    <p className="flex-1 clear-margin" onClick={()=>{this.loadJobRank(1)}}>
                        <span className={rankingTabNum===1?"rankingTab-active font-PingFangFC marginleft-24 font-16 paddingbottom-3 fontweight-24":'marginleft-25 font-16 font-PingFangFC'}>{"浏览量排名"}</span>
                    </p>
                    <p className="flex-1 textalign-center clear-margin" onClick={()=>{this.loadJobRank(2)}}>
                        <span className={rankingTabNum===2?"rankingTab-active font-PingFangFC paddingbottom-3 font-16 fontfamily-song fontweight-24":'fontfamily-song font-16 font-PingFangFC'}>{"下载量排名"}</span>
                    </p>
                    <p className="flex-1 textalign-right clear-margin" onClick={()=>{this.loadJobRank(3)}}>
                        <span className={rankingTabNum===3?"rankingTab-active font-PingFangFC marginright-24 font-16 paddingbottom-3 fontweight-24":'marginright-24 font-16 font-PingFangFC'}>{"外呼量排名"}</span>
                    </p>
                </div>
                <ul className="messageWarning clear-padding flex-1 liststyle-none background ">
                    <li className="tableul background-F7FAFF alignitem-center display-flex">
                        <span className="flex-1 font-16 fontWeight-400 font-PingFangFC textalign-left paddingleft-24">{"名次"}</span>
                        <span className="flex-1 font-16 fontWeight-400 font-PingFangFC textalign-center">{"姓名"}</span>
                        <span className="flex-1 font-16 fontWeight-400 font-PingFangFC textalign-right paddingright-26">{"工作量"}</span>
                    </li>
                    
                        {loading?<img src={require('../../img/frame/loading.gif')} className="loading-home" alt="es-lint want to get"/>:
                            <>{
                                RankData===undefined || RankData===null || RankData.length===0 ? 
                                <p style={{width:"100%",textAlign:"center",paddingTop:"100px"}}><img src={require('../../css/widget/img/no-data.svg')}></img></p> :
                                RankData.map((val,index)=>{
                                    return ( 
                                        <li className="tableul font-14 display-flex alignitem-center" key={index}>
                                            <span className="flex-1 color-323232 font-PingFangFC font-14 textalign-left paddingleft-37">{val.RANK}</span>
                                            <div className="flex-1 color-323232 font-PingFangFC font-14 textalign-center">{val.REALNAME}</div>
                                            <span className="flex-1 color-323232 font-PingFangFC font-14 textalign-right paddingright-24">{val.AMOUNT}</span>
                                        </li>
                                    )
                                })
                            }</>
                        }
                        
                    
                </ul>   
            </div>
        )
    }
}
export default AllRankingWidget